module.exports = __webpack_public_path__ + "media/elevadizo/buqueDerecha-dd-ap-7c91fc60.png";